import React, { useState } from "react";
import { FaEnvelope, FaPhoneAlt, FaLinkedin } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import nohmi1 from "../images/nohmi1.png";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmailSubmit = async (e) => {
  e.preventDefault();

  if (!email) {
    setMessage("Please enter your email address!");
    return;
  }

  setLoading(true);

  try {
    await fetch("https://script.google.com/macros/s/AKfycbzyg4HJi_h6AikEEq7VnqLZWwEDqwp1s-ZUhZSnhUn0aBzpHQA8t9K5nLu-FmRtvUSj/exec", {
      method: "POST",
      mode: "no-cors", // ✅ avoids CORS issue
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    // ✅ Success popup on full screen
    alert("✅ Email submitted successfully!");
    setEmail("");
  } catch (error) {
    console.error("Error:", error);
    alert("⚠️ Something went wrong. Please try again.");
  }

  setLoading(false);
};


  return (
    <div>
      <div className="border-[3px] border-black"></div>
      <motion.footer
        className="bg-green-700 text-white py-12"
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="container mx-auto px-6 md:px-12 xl:px-20 flex flex-col md:flex-row justify-between gap-10">
          
          {/* Left Section */}
          <div className="space-y-6 md:w-1/3">
            <div className="flex items-center space-x-3">
              <img src={nohmi1} alt="Nohmi Bosai Logo" className="w-36 h-6" />
              <h2 className="text-md mt-1">Nohmi Bosai (India) Pvt. Ltd.</h2>
            </div>

            {/* Email Input */}
            <div className="flex flex-col">
              <div className="flex">
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-3 text-gray-800 rounded-l-md outline-none"
                />
                <button
                  onClick={handleEmailSubmit}
                  disabled={loading}
                  className={`${
                    loading ? "bg-gray-400" : "bg-green-500 hover:bg-green-600"
                  } px-5 rounded-r-md transition`}
                >
                  {loading ? "..." : "➤"}
                </button>
              </div>
              {message && (
                <p
                  className={`text-sm mt-2 ${
                    message.includes("✅") ? "text-green-300" : "text-red-300"
                  }`}
                >
                  {message}
                </p>
              )}
            </div>

            {/* Contact Info */}
            <div className="mt-6 space-y-3 text-sm">
              <a
                href="mailto:info@nohmi-india.com"
                className="flex items-center space-x-3 hover:text-green-400 transition"
              >
                <FaEnvelope className="text-white" />
                <span>info@nohmi-india.com</span>
              </a>

              <a
                href="tel:01246572250"
                className="flex items-center space-x-3 hover:text-green-400 transition"
              >
                <FaPhoneAlt className="text-white" />
                <span>0124-6572250</span>
              </a>
            </div>

            <p className="text-sm">
              <span className="font-semibold text-white">Working Hours:</span>{" "}
              Monday - Friday : Standard Business Hours
            </p>

            <a
              href="https://www.linkedin.com/company/nohmibosai-india/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 bg-white text-[#0077B5] rounded-md hover:bg-[#0077B5] hover:text-white transition text-xl inline-flex items-center justify-center"
            >
              <FaLinkedin />
            </a>
          </div>

          {/* Middle Section */}
          {/* <div className="md:w-1/4">
            <h3 className="text-xl font-semibold mb-4">Our Products</h3>
            <ul className="space-y-2 text-gray-100">
              <Link to="/address"><li>› Addressable System</li></Link>
              <Link to="/smoke"><li>› Aspiration Smoke Detector</li></Link>
              <Link to="/other"><li>› Common Device</li></Link>
              <Link to="/flame"><li>› IR3 Flame Detectors</li></Link>
              <Link to="/nn100"><li>› Engineered Type (NN100)</li></Link>
              <Link to="/foam"><li>› High Expansion Foam (Perf-Ex)</li></Link>
              <Link to="/foamm"><li>› Package Type (MIDEX III)</li></Link>
              <Link to="/video"><li>› Product Videos</li></Link>
            </ul>
          </div> */}

          {/* Right Section */}

          <div className="md:w-1/3">
            <h3 className="text-2xl font-semibold mb-4">Our Products</h3>
            <ul className="space-y-2 text-gray-100 text-md">
              <Link to="/address"><li>› Addressable System</li></Link>
              <Link to="/smoke"><li>› Aspiration Smoke Detector</li></Link>
              <Link to="/other"><li>› Common Device</li></Link>
              <Link to="/flame"><li>› IR3 Flame Detectors</li></Link>
              <Link to="/nn100"><li>› Engineered Type (NN100)</li></Link>
              <Link to="/foam"><li>› High Expansion Foam (Perf-Ex)</li></Link>
              <Link to="/foamm"><li>› Package Type (MIDEX III)</li></Link>
              <Link to="/video"><li>› Product Videos</li></Link>
            </ul>
          </div>

          {/* <div className="md:w-1/4">
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-100">
              <Link to="/"><li>› Home</li></Link>
              <Link to="/about"><li>› About Us</li></Link>
              <Link to="/products"><li>› Products</li></Link>
              <Link to="/blog1"><li>› Blogs</li></Link>
              <Link to="/events"><li>› Gallery</li></Link>
              <Link to="/contact"><li>› Contact Us</li></Link>
            </ul>
          </div> */}
        </div>

        <div className="text-center mt-10 border-t border-green-600 pt-6 text-sm text-gray-200">
          © {new Date().getFullYear()} Nohmi Bosai (India) Pvt. Ltd. All Rights Reserved.
        </div>
      </motion.footer>
    </div>
  );
};

export default Footer;
